import * as apiCommon from "./apiCommon";
import * as apiQuiz from "./apiQuiz";
import * as apiProfile from "./apiProfile";
import * as apiCheckout from "./apiCheckout";
const api = { ...apiCommon, ...apiQuiz, ...apiProfile, ...apiCheckout };
export default api;
